import { Link } from 'react-router-dom';
import useAdvanceTable from '../../hooks/useAdvanceTable';
import AdvanceTableProvider from '../../providers/AdvanceTableProvider';
import { Table, Row, Col, Card } from 'react-bootstrap';
import Avatar from '../../components/base/Avatar';

import RevealDropdown, {
  RevealDropdownTrigger
} from '../../components/base/RevealDropdown';
import { currencyFormat } from '../../helpers/utils';
import ActionDropdownItems from '../../components/common/ActionDropdownItems';
import ProductionJobsProgress from '../../components/charts/production-management-charts/ProductionJobsProgress';
import { useJobs } from '../../features/jobs/hooks/useJobs';
import { Bars } from 'react-loader-spinner';
import ProductionJobsLengthLine from '../../components/charts/production-management-charts/ProductionJobLengthLine';
import ProductionTokensByPhaseStacked from '../../components/charts/production-management-charts/ProductionTokensByPhaseStacked';
import ProjectJobsMonitor from './ProjectJobsMonitor';
import ProjectBobinState from './ProjectBobinState';
import FuturePlanningSummary from '../../components/future-products/FuturePlanningSummary';
import WarehouseTransferTable from './WarehouseTransferTable';

const dealsReportData = [
  {
    dealName: 'Jo_Td01',
    dealOwner: {
      name: 'Ally Aagaard',
      profileLink: '#!'
    },
    accountName: 'Themewagon',
    stage: {
      label: 'Analysis',
      value: 20
    },
    amount: {
      value: 140,
      trending: 'down'
    }
  },
  {
    dealName: 'Printing Dimensions',
    dealOwner: {
      //   avatar: team35,
      name: 'Alex Abadi',
      profileLink: '#!'
    },
    accountName: 'Black Box',
    stage: {
      label: 'Statement',
      value: 40
    },
    amount: {
      value: 214,
      trending: 'up'
    }
  },
  {
    dealName: 'MM_TD_120',
    dealOwner: {
      //   avatar: team32,
      name: 'Kylia Abbott',
      profileLink: '#!'
    },
    accountName: 'Hunter Leader',
    stage: {
      label: 'Action',
      value: 50
    },
    amount: {
      value: 412,
      trending: 'up'
    }
  },
  {
    dealName: 'Truhlar And Truhlar Attys',
    dealOwner: {
      //   avatar: team32,
      name: 'Kylia Abbott',
      profileLink: '#!'
    },
    accountName: 'Eagle Eye',
    stage: {
      label: 'Offering',
      value: 60
    },
    amount: {
      value: 110,
      trending: 'up'
    }
  },
  {
    dealName: 'Morlong Associates',
    dealOwner: {
      //   avatar: team59,
      name: 'Lyla Nicole',
      profileLink: '#!'
    },
    accountName: 'Black Box',
    stage: {
      label: 'Negotiation',
      value: 100
    },
    amount: {
      value: 325,
      trending: 'down'
    }
  },
  {
    dealName: 'Product Order',
    dealOwner: {
      //   avatar: team18,
      name: 'Hunter Leader',
      profileLink: '#!'
    },
    accountName: 'Themewagon',
    stage: {
      label: 'Negotiation',
      value: 100
    },
    amount: {
      value: 198,
      trending: 'down'
    }
  },
  {
    dealName: 'Feltz Printing Service',
    dealOwner: {
      name: 'Ally Aagaard',
      profileLink: '#!'
    },
    accountName: 'Themewagon',
    stage: {
      label: 'Offering',
      value: 80
    },
    amount: {
      value: 142,
      trending: 'up'
    }
  },
  {
    dealName: 'Flat Plate SP',
    dealOwner: {
      name: 'Ally Aagaard',
      profileLink: '#!'
    },
    accountName: 'Eagle Eye',
    stage: {
      label: 'Offering',
      value: 80
    },
    amount: {
      value: 457,
      trending: 'up'
    }
  },
  {
    dealName: 'Evacuated Tube',
    dealOwner: {
      name: 'Ally Aagaard',
      profileLink: '#!'
    },
    accountName: 'Hunter Leader',
    stage: {
      label: 'Action',
      value: 100
    },
    amount: {
      value: 120,
      trending: 'down'
    }
  },
  {
    dealName: 'Product Delivery',
    dealOwner: {
      //   avatar: team35,
      name: 'Alex Abadi',
      profileLink: '#!'
    },
    accountName: 'Themewagon',
    stage: {
      label: 'Analysis',
      value: 100
    },
    amount: {
      value: 150,
      trending: 'down'
    }
  },
  {
    dealName: 'Product Order',
    dealOwner: {
      //   avatar: team18,
      name: 'Hunter Leader',
      profileLink: '#!'
    },
    accountName: 'Themewagon',
    stage: {
      label: 'Negotiation',
      value: 100
    },
    amount: {
      value: 140,
      trending: 'down'
    }
  },
  {
    dealName: 'Feltz Printing Service',
    dealOwner: {
      name: 'Ally Aagaard',
      profileLink: '#!'
    },
    accountName: 'Themewagon',
    stage: {
      label: 'Offering',
      value: 80
    },
    amount: {
      value: 122,
      trending: 'up'
    }
  },
  {
    dealName: 'Flat Plate SP',
    dealOwner: {
      name: 'Ally Aagaard',
      profileLink: '#!'
    },
    accountName: 'Eagle Eye',
    stage: {
      label: 'Offering',
      value: 80
    },
    amount: {
      value: 321,
      trending: 'up'
    }
  },
  {
    dealName: 'Evacuated Tube',
    dealOwner: {
      name: 'Ally Aagaard',
      profileLink: '#!'
    },
    accountName: 'Hunter Leader',
    stage: {
      label: 'Action',
      value: 100
    },
    amount: {
      value: 104,
      trending: 'down'
    }
  },
  {
    dealName: 'Product Delivery',
    dealOwner: {
      //   avatar: team35,
      name: 'Alex Abadi',
      profileLink: '#!'
    },
    accountName: 'Themewagon',
    stage: {
      label: 'Analysis',
      value: 100
    },
    amount: {
      value: 124,
      trending: 'down'
    }
  }
];

export const dealsReportColumns = [
  {
    accessorKey: 'dealName',
    header: 'Deal Name',
    cell: ({ row: { original } }) => (
      <Link to="#!" className="fw-bold text-primary">
        {original.dealName}
      </Link>
    ),
    meta: {
      headerProps: {
        style: { minWidth: 120 },
        className: 'pe-5 text-nowrap'
      },
      cellProps: {
        className: 'white-space-nowrap pe-5'
      }
    }
  },
  {
    id: 'deal_owner',
    accessorFn: ({ dealOwner }) => dealOwner.name,
    header: 'Deal Owner',
    cell: ({ row: { original } }) => {
      const { name, avatar, profileLink } = original.dealOwner;
      return (
        <Link to={profileLink} className="d-flex align-items-center text-body">
          {/* <Avatar src={avatar} size="m" /> */}
          <p className="mb-0 ms-3 text-body-emphasis fw-bold">{name}</p>
        </Link>
      );
    },
    meta: {
      headerProps: {
        style: { minWidth: 50 },
        className: 'pe-5 text-nowrap'
      },
      cellProps: { className: 'white-space-nowrap pe-5 py-0' }
    }
  },
  {
    accessorKey: 'accountName',
    header: 'Account Name',
    meta: {
      headerProps: {
        style: { minWidth: 250 },
        className: 'text-nowrap'
      },
      cellProps: {
        className: 'white-space-nowrap fw-semibold text-body'
      }
    }
  },
  {
    id: 'stage',
    accessorFn: ({ stage }) => stage.label,
    header: 'Stage',
    cell: ({ row: { original } }) => {
      const { label, value } = original.stage;
      return (
        <div className="d-flex align-items-center gap-3">
          <div style={{ '--phoenix-circle-progress-bar': value }}>
            {/* <CircleProgress color={getColor(getProgressColorVariant(value))} /> */}
          </div>
          <h6 className="mb-0 text-body">{label}</h6>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { minWidth: 160 },
        className: 'pe-5 ps-4'
      },
      cellProps: {
        style: { paddingTop: 1, paddingBottom: 1 },
        className: 'white-space-nowrap fw-bold text-body pe-5 overflow-hidden'
      }
    }
  },

  {
    id: 'action',
    cell: () => (
      <RevealDropdownTrigger>
        <RevealDropdown>
          <ActionDropdownItems />
        </RevealDropdown>
      </RevealDropdownTrigger>
    ),
    meta: {
      headerProps: {
        className: 'text-end ps-4'
      },
      cellProps: { className: 'text-end ps-4 py-0' }
    }
  }
];

const ProjectMonitor = () => {
  const { data: jobs = [], isLoading, isFetching, error } = useJobs();

  const table = useAdvanceTable({
    data: dealsReportData,
    columns: dealsReportColumns,
    pageSize: 10,
    selection: true,
    pagination: true,
    sortable: true
  });

  return (
    <AdvanceTableProvider {...table}>
      <div className="pb-9">
        <h2 className="mb-4">Project Monitor</h2>

        <Row className="gy-2">
          <Col xs={12} lg={6} xl={6} xxl={6}>
            <Card>
              <Card.Body>
                <div className="mb-5">
                  {isLoading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: 360 }}>
                      <Bars height="50" width="50" color="#3874ff" ariaLabel="loading" />
                    </div>
                  ) : (
                    <ProductionJobsProgress
                      jobs={jobs}
                      style={{ height: 360, width: '100%' }}
                    />
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} lg={6} xl={6} xxl={6}>
            <Card>
              <Card.Body>
                <div className="mb-5">
                  {isLoading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: 360 }}>
                      <Bars height="50" width="50" color="#3874ff" ariaLabel="loading" />
                    </div>
                  ) : (
                    <ProductionTokensByPhaseStacked
                      jobs={jobs}
                      style={{ height: 360 }}
                    />
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
          {/* <Col xl={5} xxl={4}>
            <Card>
              <Card.Body>
                <div className="mb-5">
                  <ProductionJobsLengthLine
                    jobs={jobs}
                    style={{ height: 360, width: '100%' }}
                  />
                </div>
              </Card.Body>
            </Card>
          </Col> */}
        </Row>
      </div>

      <Row className="gy-2">
        <Col>
          <ProjectJobsMonitor jobs={jobs} />
        </Col>
      </Row>

      {/* The full-bleed band belongs on a plain div, not on the Row.
          A Row already carries its own negative gutter margins; mx-n4 on top of
          them made it -2.25rem a side against +1.5rem of padding, so the section
          hung 0.75rem past the viewport on both sides — which is where the
          horizontal scrollbar on this page came from. */}
      <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis pt-6 border-top border-300">
        <Row>
          <Col>
            <ProjectBobinState />
          </Col>
        </Row>
      </div>

      {/* Future planning (same as /future-products): charts + prepared products,
          embedded here as a read-only "what's planned next" section under the live
          bobin state. Shared component — no code duplication. */}
      <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 pt-6 border-top border-300">
        <Row>
          <Col>
            <FuturePlanningSummary title="Future planning" />
          </Col>
        </Row>
      </div>

      {/* Production → Warehouse: own tinted card so it reads as a separate
          section, not a continuation of Project Bobin State */}
      <Row className="gy-2 mt-4 mb-5">
        <Col>
          <Card className="border-start border-4 border-info bg-body-emphasis shadow-sm">
            <Card.Body>
              <WarehouseTransferTable />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </AdvanceTableProvider>
  );
};

export default ProjectMonitor;
